export enum MobileType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Other = 'OTHER',
}

export const MobileTypeDisplayName = {
  [MobileType.Android]: 'Android',
  [MobileType.Ios]: 'IOS',
  [MobileType.Other]: 'Other',
};